export default __webpack_public_path__ + "static/media/ic_llp_30.5163fd34.svg";